<template>

<div class="vm-card card-shadow"
    :class="[
        {'vm-card-list' : list},
        {'vm-card-listc' : compactList},
        {'vm-card-collapsed' : collapsed},
        {'vm-card-collapsable' : collapsable},
    ]">
    <div v-if="header" class="vm-card-header-c" @click="handleClick">
        <div class="vm-card-header">
            <label class="no-select">{{ header }}</label>
        </div>
        <div class="vesc-actions">
            <slot name="actions"></slot>
        </div>
    </div>
    <div v-if="!collapsed" class="vm-card-content" :class="{'vm-card-np' : noPadding}">
        <slot></slot>
    </div>
</div>

</template>
<script>

export default {
    name: 'vm-card',
    props: {
        header: {
            type: String,
            default: ''
        },
        noPadding: {
            type: Boolean,
            default: false
        },
        list: {
            type: Boolean,
            default: false
        },
        compactList: {
            type: Boolean,
            default: false
        },
        collapsable: {
            type: Boolean,
            default: false
        },
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick() {
            if (!this.collapsable) return;
            this.$emit('collapse', this.collapsable);
        }
    }
}
</script>
<style>

.vm-card {
    position: relative;
    float: left;
    width: 100%;
    border-radius: 3px;
    background-color: white;
}

.vm-card-list {
    margin-bottom: 20px;
}
.vm-card-listc {
    margin-bottom: 10px;
}

.vm-card-header-c {
    position: relative;
    float: left;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    background-color: #004976;
    box-sizing: border-box;
}
.vm-card-collapsed .vm-card-header-c {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
}
.vm-card-collapsable .vm-card-header-c {
    cursor: pointer;
}

.vm-card-header {
    padding-top: 15px;
    padding-bottom: 10px;
}
.vm-card-header label {
    font-size: 16px;
    color: white;
}
.vm-card-collapsable .vm-card-header label {
    cursor: pointer;
}

.vm-card-content {
    float: left;
    width: 100%;
    padding: 15px 20px;
    box-sizing: border-box;
}

.vm-card-np {
    padding: 0px;
}

.vesc-actions {
    position: absolute;
    top: 0px; right: 0px;
}

</style>